import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const logo = (
    <Box
      component="img"
      src="/logo.png"
      sx={{
        width: 60,
        height: 60,
        borderRadius: '50%',
        objectFit: 'cover',
        cursor: 'pointer',
        backgroundColor: '#FFF', // Solid white background for visibility
        padding: '2px', // Slight padding so the logo doesn't touch the edges
        boxShadow: (theme) => theme.customShadows.z8,
        ...sx
      }}
    />
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="/">{logo}</RouterLink>;
}
